<script setup lang="ts">
import { mdiCheckCircleOutline, mdiInformationOutline, mdiAlertCircleOutline, mdiClose } from "@mdi/js";

const getIcon = (type: string) => {
	switch (type) {
		case "success":
			return mdiCheckCircleOutline;
		case "info":
			return mdiInformationOutline;
		default:
			return mdiAlertCircleOutline;
	}
};
</script>

<template>
	<Toast
		position="bottom-left"
		:pt="{
			container: {
				class: tw`lg:max-w-[400px] max-w-[100%] rounded-lg border p-2 flex w-full mb-4`,
			},
			content: {
				class: tw`w-full`,
			},
		}"
	>
		<template #message="slotProps">
			<div
				:class="[
					'rounded-full w-8 h-8 flex items-center justify-center text-light-50',
					{
						'bg-primary-600': slotProps.message.severity === 'success',
						'bg-casino-600': slotProps.message.severity === 'info',
						'bg-error-600': slotProps.message.severity === 'error',
						'bg-warning-600': slotProps.message.severity === 'warn',
					},
				]"
			>
				<UiIcon :path="getIcon(slotProps.message.severity)"></UiIcon>
			</div>
			<div class="flex items-center flex-1 h-full px-4 flex-column">
				<div class="text-sm leading-4 sm:text-base sm:leading-5">
					<div class="font-bold">{{ slotProps.message.summary }}</div>
					<div v-if="slotProps.message.detail">{{ slotProps.message.detail }}</div>
				</div>
			</div>
		</template>
		<template #closeicon>
			<div class="flex items-center justify-center w-8 h-8 rounded outline-none bg-light-50">
				<UiIcon :path="mdiClose" class="w-5 h-5" />
			</div>
		</template>
	</Toast>
</template>

<style lang="scss">
.p-toast {
	width: 100% !important;
	padding: 0 10px;
	max-width: 400px;
	left: 0 !important;
}
.p-toast-message {
	&.p-toast-message-success {
		@apply bg-primary-50 border-primary-100 dark:bg-primary-900 dark:border-primary-500;
	}
	&.p-toast-message-info {
		@apply bg-casino-50 border-casino-100 dark:bg-casino-900 dark:border-casino-500;
	}
	&.p-toast-message-error {
		@apply bg-error-50 border-error-100 dark:bg-error-900 dark:border-error-500;
	}
	&.p-toast-message-warn {
		@apply bg-warning-50 border-warning-100 dark:bg-warning-900 dark:border-warning-500;
	}
}
</style>
